import styled from 'styled-components';
import { Grid, Typography, ButtonWithArrowRight } from '~components';
import { ISpacing } from './types';

export const Spacing = styled.div<ISpacing>`
  margin-top: ${({ theme, spacing }) => theme.spacing[`km${spacing ?? 4}`]};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km10};
  }
`;

export const Button = styled(ButtonWithArrowRight)`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-top: ${({ theme }) => theme.spacing.km6};
    margin-bottom: ${({ theme }) => theme.spacing.km0};
  }
`;

export const Text = styled(Typography).attrs({ as: 'p' })`
  color: ${({ theme }) => theme.color.text.neutral.weak};
`;

export const IconWrapper = styled.span`
  margin-left: ${({ theme }) => theme.spacing.km1};
`;

export const FieldRow = styled(Grid).attrs({
  'data-testid': 'field-row',
  container: true,
  direction: 'row' as const,
  directionSm: 'column' as const,
})``;
